import { createSlice } from '@reduxjs/toolkit'
import { ADD } from '../constants/segmentSelectionToolbox'

const initialState = {
  activeTool: ADD
}

const segmentSelectionToolbox = createSlice({
  name: 'segmentSelectionToolbox',
  initialState,
  reducers: {
    setActiveTool(state, action) {
      state.activeTool = action.payload
    }
  }
})

export const { setActiveTool } = segmentSelectionToolbox.actions
export default segmentSelectionToolbox.reducer
